import React from 'react';
import classNames from 'classnames';
import { HTMLMotionProps, motion } from 'framer-motion';

import styles from './shiny-button.module.scss';

const animationProps = {
  initial: { '--x': '100%', scale: 0.98 },
  animate: { '--x': '-100%', scale: 1 },
  whileTap: { scale: 0.95 },
  transition: {
    repeat: Infinity,
    repeatType: 'loop' as const,
    repeatDelay: 1,
    type: 'spring' as const,
    stiffness: 20,
    damping: 15,
    mass: 2,
    scale: {
      type: 'spring' as const,
      stiffness: 200,
      damping: 5,
      mass: 0.5,
    },
  },
};

interface Props extends HTMLMotionProps<'button'> {
  children: React.ReactNode;
  className?: string;
}

const ShinyButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ children, className, ...props }, ref) => {
    return (
      <motion.button
        ref={ref}
        {...animationProps}
        className={classNames(styles.shinyButton, className)}
        {...props}
      >
        <span className={styles.text}>{children}</span>
        <span className={styles.glow} />
      </motion.button>
    );
  },
);

ShinyButton.displayName = 'ShinyButton';

export default ShinyButton;
